import React from "react";
import "../styles/CumFunctioneaza.css";

const CumFunctioneaza = () => {
  return (
    <section className="section section-container">
      <div className="section-overlay">
        <h1 className="heading-secondary">Cum funcționează?</h1>
        <p className="subheading">
          Ușor! Alege un buchet, iar noi ne ocupăm de restul!
        </p>
        <div className="grid-container grid-container-col-3">
          {/* First Grid Item */}
          <div className="grid-item grid-item-func">
            <i className="fa fa-question-circle icon"></i>
            <h2 className="grid-title">Care e povestea ta?</h2>
            <p className="grid-text">Pentru cine este acest buchet?</p>
            <p className="grid-text">
              Ce emoție vrei să transmiți? Alege florile care spun cel mai bine
              ceea ce simți.
            </p>

            <div className="grid-number">1</div>
          </div>
          {/* Second Grid Item */}
          <div className="grid-item grid-item-func">
            <i className="fa fa-leaf icon"></i>
            <h2 className="grid-title">Alege buchetul preferat</h2>
            <p className="grid-text">
              Ne dedicăm pasiunii pentru design floral, alegând flori proaspete
              și parfumate, cu un stil rafinat și o atenție deosebită la
              detalii.
            </p>
            <div className="grid-number">2</div>
          </div>
          {/* Third Grid Item */}
          <div className="grid-item grid-item-func">
            <i className="fa fa-heart icon"></i>
            <h2 className="grid-title">Livrăm bucurie prin flori</h2>
            <p className="grid-text">
              Fiecare buchet este livrat cu grijă și eleganță, gata să aducă un
              zâmbet și o emoție de neuitat celui care îl primește.
            </p>
            <div className="grid-number">3</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CumFunctioneaza;
